import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/logo_project.png";
import "./ChatInit.css";
import Swal from "sweetalert2";
import ScaleLoader from "react-spinners/ScaleLoader";
import { createChat } from "../../api/api";
import { useEffect } from "react";

const ChatInit = () => {
    const navigate = useNavigate();
    const [codigoProducto, setCodigoProducto] = useState("");
    const [descripcionProducto, setDescripcionProducto] = useState("");
    const [isNavigating, setIsNavigating] = useState(false);
    const [searchType, setSearchType] = useState<"codigo" | "descripcion">("codigo");
    const [showExtraButtons, setShowExtraButtons] = useState(false);

    useEffect(() => {
        // Check if user exists and is rpabot4@haceb.com
        const roles = sessionStorage.getItem("roles");
        //setShowExtraButtons(true);
        if (roles && (JSON.parse(roles).includes("wilson.tecnicos") || JSON.parse(roles).includes("wilson.terceros"))) {
            setShowExtraButtons(true);
        }
    }, []);

    // Original handleIrClick method - only for search by code
    const handleIrClick = async () => {
        if(codigoProducto.trim() !== ""){
            setIsNavigating(true); 
            sessionStorage.setItem("CodigoProducto", codigoProducto);
            sessionStorage.setItem("SearchType", "codigo");
            const userId = sessionStorage.getItem("userEmail") || "";
            const userName = sessionStorage.getItem("userName") || "";

            // Creating the chat using the API with product code
            try {
                const response = await createChat(codigoProducto, userId, userName);
                if (response) {
                    console.log("Chat created successfully with code:", response);
                    // Navigate to the chat page
                    await navigate(`/chatv2/${response.chat.id}`);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Error creating chat with product code",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#2f9f91"
                    });
                }
            } catch (error) {
                console.error("Error creating chat with code:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An unexpected error occurred while creating the chat with product code.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#2f9f91"
                });
            }
        } else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ingrese el código de producto",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#2f9f91"
            });
        }
        setIsNavigating(false); 
    };

    // New function for search by description
    const searchByDescription = async () => {
        if(descripcionProducto.trim() !== ""){
            setIsNavigating(true);
            
            // Navigate to the description search results page
            navigate(`/search-description/${encodeURIComponent(descripcionProducto)}`);
            
            setIsNavigating(false);
        } else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ingrese la descripción del producto",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#2f9f91"
            });
        }
    };

    const handleCodigoProductoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCodigoProducto(event.target.value);
    };

    const handleDescripcionProductoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDescripcionProducto(event.target.value);
    };

    const handleSearchTypeChange = (type: "codigo" | "descripcion") => {
        setSearchType(type);
        // Clear the inputs when switching
        setCodigoProducto("");
        setDescripcionProducto("");
    };

    // const handlePowerAppClick = () => {
    //     window.location.href = " https://apps.powerapps.com/play/f9f30cb2-f6de-4d56-b05b-21e99fc26896?tenantId=5368fc5a-2692-4a6a-b226-e2802e94e22b&source=portal ";
    // };

    // Nueva función: no hace nada
    const handlePowerAppClick = () => {
        // Link deshabilitado temporalmente
    };

    return (
        <div className="auth-container">
            <div className="auth-background">
                <div className="hero-content">
                    <div className="container-logo">
                        <img src={logo} alt="" className="logo" />
                    </div>
                    <h1>Soy Wilson, tu Asistente Experto</h1>
                    <p>
                        Te ayudo a consultar rápidamente información de productos, accediendo mediante lenguaje natural a manuales, guías de reparación y documentación interna para resolver dudas y agilizar tu trabajo.
                    </p>
                </div>
            </div>
            <div className="auth-container-form">
                <div className="container-card">
                <div className="form-container" style={{ marginTop: "-32px" }}>
                    {/* Card title + subtitle */}
                    <div className="card-header">
                        <h2>Buscar Producto</h2>
                        <p className="card-subtitle">Ingresa el Código o la Descripción para comenzar</p>
                    </div>

                    {/* Search Type Selector */}
                    <div className="search-type-selector">
                        <label>Buscar por:</label>
                        <div className="radio-group">
                            <label className="radio-option">
                                <input 
                                    type="radio" 
                                    name="searchType" 
                                    value="codigo"
                                    checked={searchType === "codigo"}
                                    onChange={() => handleSearchTypeChange("codigo")}
                                />
                                Código de Producto
                            </label>
                            <label className="radio-option">
                                <input 
                                    type="radio" 
                                    name="searchType" 
                                    value="descripcion"
                                    checked={searchType === "descripcion"}
                                    onChange={() => handleSearchTypeChange("descripcion")}
                                />
                                Descripción del Producto
                            </label>
                        </div>
                    </div>

                    {/* Conditional Input Fields */}
                    {searchType === "codigo" ? (
                        <>
                            <label htmlFor="codigoProducto">Ingrese el código del producto</label>
                            <input 
                                type="text" 
                                name="codigoProducto" 
                                id="codigoProducto" 
                                value={codigoProducto} 
                                onChange={handleCodigoProductoChange}
                                placeholder="Ej: ABC123"
                                autoFocus
                            />
                        </>
                    ) : (
                        <>
                            <label htmlFor="descripcionProducto">Ingrese la descripción del producto</label>
                            <input 
                                type="text" 
                                name="descripcionProducto" 
                                id="descripcionProducto" 
                                value={descripcionProducto} 
                                onChange={handleDescripcionProductoChange}
                                placeholder="Ej: refrigerador, lavadora, calentador..."
                                autoFocus
                            />
                        </>
                    )}

                    {/* Submit Button - calls different functions based on search type */}
                    {isNavigating ? (
                        <ScaleLoader color="#2f9f91" height={15} width={2} radius={2} margin={2} />
                    ) : (
                        <button
                            type="button"
                            className="power-app-btn action-btn"
                            onClick={searchType === "codigo" ? handleIrClick : searchByDescription}
                            aria-label="Iniciar"
                        >
                            <div className="power-app-btn-content">
                                <span className="power-app-btn-title">Iniciar</span>
                            </div>
                            <span className="power-app-btn-arrow" aria-hidden="true">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true">
                                    <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                        </button>
                    )}

                    {/* Power App Section */}
                    {showExtraButtons && (
                        <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "8px" }}>
                            <label htmlFor="">Aplicaciones</label>

                            <button
                                type="button"
                                className="power-app-btn action-btn"
                                onClick={() =>
                                    window.open(
                                        "https://apps.powerapps.com/play/e/default-5368fc5a-2692-4a6a-b226-e2802e94e22b/a/f9f30cb2-f6de-4d56-b05b-21e99fc26896?tenantId=5368fc5a-2692-4a6a-b226-e2802e94e22b&hint=2957ac4f-c088-42aa-a7ff-d417173b4239&sourcetime=1759258069150",
                                        "_blank"
                                    )
                                }
                            >
                                <div className="power-app-btn-content">
                                    <span className="power-app-btn-title">App Precios Repuestos</span>
                                    <span className="power-app-btn-subtitle">Ingresar</span>
                                </div>
                                <span className="power-app-btn-arrow" aria-hidden="true">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </span>
                            </button>

                            <button
                                type="button"
                                className="power-app-btn action-btn"
                                onClick={() =>
                                    window.open(
                                        "https://apps.powerapps.com/play/e/default-5368fc5a-2692-4a6a-b226-e2802e94e22b/a/8e4ff718-1b15-4283-ae5b-e07aa487335b?tenantId=5368fc5a-2692-4a6a-b226-e2802e94e22b&hint=90b61bd1-a11a-4f52-8db2-be646598a7e4&sourcetime=1759522315484",
                                        "_blank"
                                    )
                                }
                            >
                                <div className="power-app-btn-content">
                                    <span className="power-app-btn-title">App Consignación de Servicios</span>
                                    <span className="power-app-btn-subtitle">Ingresar</span>
                                </div>
                                <span className="power-app-btn-arrow" aria-hidden="true">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    )}
                </div>
                </div>
            </div>
        </div>
    );
};

export default ChatInit;